module.exports = __webpack_public_path__ + "img/about-bio-cover@2x.68a3f014.jpg";